"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const grey = {
  0: '#fff',
  200: '#f2f2f2',
  300: '#f1f2f2',
  350: '#e1e1e1',
  400: '#cccccc',
  500: '#6A6A6A',
  550: '#565656',
  600: '#333333',
  700: '#4a4a4a',
  900: '#282828',
  1000: '#000'
};
const colors = {
  grey,
  black: grey[900],
  blackContrast: grey[0],
  blackDarkest: grey[1000],
  errorBackground: '#ffecdc80',
  // '80' on the end is 80% opacity
  primaryLightest: '#e4e5f3',
  primaryLight: '#cdd1e5',
  primary: '#485cc7',
  primaryDark: '#2b439c',
  primaryHover: '#354bbf',
  secondary: '#001e63',
  success: '#00746d',
  red: '#bd411d',
  purple: '#b6b8dc',
  white: grey[0],
  textBlack: grey[900],
  textPrimary: '#001e63'
};
var _default = exports.default = colors;